import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import { axiosPut } from 'shared/api/axios'
import displayError from 'shared/utils/displayError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  setError: Function
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false
  const data: {email : string | null} = {
    'email': props.data.email ?? null,
  }
  props.setShowOverlay(true)

  const catchFunc = (err: AxiosError) => {
    displayError({
      errorMessage: err?.response?.data?.message ?? 'An error has occurred.',
      setShowOverlay: props.setShowOverlay,
    })
  }

  //update settings on the server and update Store
  response = await axiosPut(apiUrls.settings + '/' + apiUrls.actionEmailNotification, data, catchFunc)

  return true
}

export default submitForm
